import FetchGetDataWithAuthNEW from "../services/FetchGetDataWithAuthNEW";

export default function FechGetUpdateTicketStatusPayment(token) {
  var url = "/reservation/status_user_online_update_ticket/" + token;

  return FetchGetDataWithAuthNEW(url);
}
